<template>
    <layout :showuserinfo="false">
        <div class="page-wrapper-portal" style="background-color:#ffcf00">
            <zen-one :showuserinfo="false" title="Pentadbiran" :crumbs="crumbs">
                <z-page title="Senarai Pengurusan Integrasi">

                    <w-dialog
                        v-model="dialog.show"
                        :fullscreen="dialog.fullscreen"
                        :width="dialog.width"
                        :persistent="dialog.persistent"
                        :persistent-no-animation="dialog.persistentNoAnimation"
                        title-class="primary-dark1--bg white">
                        <template #title>
                          <w-icon class="mr2">fal fa-cog</w-icon>
                           <template v-if="form.id">
                                 Kemaskini Integrasi
                            </template>
                            <template v-else>
                                Daftar Integrasi
                            </template>
                        </template>
                        <w-form 
                            ref="form" 
                            v-model="dialog.valid"
                            @validate="submit"
                            @success="success"
                            >
                            <div class="xs4">
                             <h5 class="fw-semibold m0">
                                          Maklumat Integrasi
                                </h5>
                            </div>
                                <z-input label="Nama Sistem" v-model="form.keterangan" name="keterangan" :validators="[validators.required]" />
                                <z-input label="ID Integrasi" v-model="form.id_integrasi" name="id_integrasi" :validators="[validators.required]" />
                                <z-input label="Kata Laluan Integrasi" v-model="form.kata_laluan_integrasi" name="kata_laluan_integrasi" :validators="[validators.required]" />
                                <z-input label="URL Integrasi" v-model="form.url_produksi_integrasi" name="url_produksi_produksi" :validators="[validators.required]" />
                                <br>
                                <div class="xs4">
                                          Standard Integrasi : 
                                        <w-switch class="mr6" v-model="form.am"></w-switch>
                                </div>
                                <br>
                                    <div class="xs4">
                                        
                                              Status: 
                                            <w-switch class="mr6" v-model="form.status"></w-switch>
                                    </div>
                                <br>
                                <div class="xs4">
                                 <h5 class="fw-semibold m0">
                                              Maklumat iBAYAQ
                                    </h5>
                                </div>
                                    <z-input label="URL Ibayaq" v-model="form.url_produksi_ibayaq" name="url_produksi_ibayaq" :validators="[validators.required]" />

                                <br>
                                <br>
                                
                        </w-form>
                        <template #actions>
                              <div class="spacer" />
                              <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Close</w-button>
                              <w-button 
                              class="ml1" 
                              :loading="dialog.loading"
                              :disabled="dialog.valid === false"
                              @click="$refs.form.validate()"
                              >
                                Save
                              </w-button>
                        </template>  

                    </w-dialog>
              
                    <z-table
                        ref="tbluser"
                        :headers="table.headers"
                        :items="table.items"
                        :meta="table.meta"
                        class=""
                      >
                        <template #button>
                            <w-button dark class="indigo-dark2--bg ml1" @click="add(null)">
                                <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                            </w-button>
                        </template>  

                         <template #header-label="{ header, label, index }">
                            <template v-if="header.key == 'action'">
                                Tindakan
                            </template>
                        </template>

                        <template #item-cell.action="{ item, label, header, index }">
                            <w-flex class="flex justify-center">
                                 <w-button dark class="indigo-dark2--bg ml1" @click="edit(item)">
                                        <w-icon class="mr1" >fal fa-pencil</w-icon>  Kemaskini
                                </w-button>

                                 <w-button dark class="indigo-dark2--bg ml1" @click="destroy(item)">
                                    <w-icon dark tile>fal fa-trash</w-icon> Padam
                                </w-button>
                            </w-flex>
                        </template>
                    </z-table>

                </z-page>
            </zen-one>
        </div>
    </layout>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'pengurusan_integrasi',
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pengurusan Integrasi', route: '/pengurusan_integrasi' }
      ],
     
      form: {
        id: 0,
        keterangan : '',
        id_integrasi : '',
        kata_laluan_integrasi : '',
        url_produksi_integrasi : '',
        am : '',
        status : '',
        url_produksi_ibayaq : '',
        user_id : '',
      }
    }
  },
  methods: {
    add(){
          this.form = {
            id : null,
            keterangan : null,
            id_integrasi : null,
            kata_laluan_integrasi : null,
            url_produksi_integrasi : null,
            am : null,
            status : null,
            url_produksi_ibayaq :null,
            user_id : null,
              
              

          }
          this.dialog.show = true
          this.form.saveButton = "Save"
      },
      edit(form){
          this.form = form
          this.dialog.show = true
          this.form.saveButton = "Save"
      },

       submit(form){
        // alert(this.form.id);

      // this.form.lkp_inbois_status_id = status
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$route('Integrasi.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },


      
  
  },

  watch: {

  },
  mounted() {
    // override default setting

    this.dialog.width = 800
      
  },
}
</script>
